export default __webpack_public_path__ + "static/media/beit-kneset1-mission.12381fb7.png";